export default __webpack_public_path__ + "static/sobczyk-be9f0cae25745d0529d3c6ce3f362fd3.jpg";